import React, { Fragment, useEffect, useState } from 'react'
import styles from './TabButtonsLine.module.scss'
import { PageTopContainer } from 'pages/utils'
import { Button, StatisticElement } from 'components'
import { TabButtonProps } from './types'
import { VIEWERS_STORE, ViewerPageTabTypes } from 'store'
import { IconWatching, IconInteract, IconRevenue, IconTotalBill } from 'assets'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import cl from 'classnames'
import { useGetIsResponsiveScreen } from 'utilities'

const TabButtonsLineComponent = (props: TabButtonProps) => {
  const {
    [VIEWERS_STORE]: {
      currentViewer: viewer,
      viewerPageSelectedTab: selectedTab,
      selectViewerPageTab
    }
  } = props

  const tabs = [
    {
      icon: IconWatching,
      label: ViewerPageTabTypes.TOTAL_WATCH_VIDEO,
      value: viewer.totalWatchTimeAsString
    },
    {
      icon: IconInteract,
      label: ViewerPageTabTypes.TOTAL_INTERACTION_TIME,
      value: viewer.totalInteractionTimeAsString
    },
    {
      icon: IconRevenue,
      label: ViewerPageTabTypes.ADD_REVENUE,
      value: viewer.totalAddRevenueAsString
    },
    {
      icon: IconTotalBill,
      label: ViewerPageTabTypes.TOTAL_SPEND,
      value: viewer.totalSpentAsString
    }
  ]
  const selectedTabIndex = tabs.map(t => t.label).findIndex(tab => tab === selectedTab)
  const { isResponsive: isLargeMobile } = useGetIsResponsiveScreen('(max-width: 700px)')

  return (
    <PageTopContainer preset='grey'>
      <div className={cl((isLargeMobile && styles.flexWrap), styles.flexRow, styles.widthFull) }>
        {tabs.map((bttn, index) => {
          const selected = selectedTab === bttn.label
          const renderSeparator = !selected && selectedTabIndex - index !== 1

          return (
            <Fragment key={index}>
              <Button
                type='tab'
                selected={selected}
                onClick={() => selectViewerPageTab(bttn.label)}
              >
                <StatisticElement {...bttn} />
              </Button>
              {renderSeparator && <div className={styles.separator} />}
            </Fragment>
          )
        })}
      </div>
    </PageTopContainer>
  )
}

const TabButtonsLine = inject(VIEWERS_STORE)(observer(TabButtonsLineComponent))
export { TabButtonsLine }
